module.exports = __webpack_public_path__ + "img/SNS2.072692aa.png";